import React from 'react';
import clsx from 'clsx';
import { withTranslation } from 'react-i18next';
import Button from '../button';
import styles from './index.scss';
import Image from '../image';

function MobileOnly(props) {
  const { className, t, i18n, onContinue } = props;

  return (
    <div className={clsx(className, 'mobileOnly', styles.container)}>
      <div>
        <Image
          src={
            i18n.exists('mobile-only.background_image.src')
              ? t('mobile-only.background_image.src')
              : ''
          }
        />
        {onContinue && (
          <Button className={styles.button} text={t('mobile-only.continue')} onClick={onContinue} />
        )}
      </div>
    </div>
  );
}

export default withTranslation()(MobileOnly);
